/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { forwardRef } from 'react';
import HeaderButton from './HeaderButton';
import Row from './Row';

const Component = (_, ref) => (
    <div ref={ref}>
      <Row>
        <div
          css={css(`
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
          `)}
        >
          METRICS
        </div>
        <div
          css={css(`
            padding-right: 15px;
            text-align: right;
            color: #999;
            font-size: 1rem;
        `)}
        >
          <HeaderButton />
        </div>
      </Row>
    </div>
  );

export default (forwardRef<any, any>(Component): React$AbstractComponent<any, any>);
